// Libraries
import { Box, Card, Flex, Link, TableContainer, Text } from '@chakra-ui/react';
import dynamic from 'next/dynamic';
import NextLink from 'next/link';
// Components
import { Spinner } from '@atoms/index';
// Utils
import { AppPath } from '@constants/index';
import text from '@translations/en.json';
// Types
import { CiiSummaryCardProps } from './CiiSummaryCard.types';

const SummaryTable = dynamic(() => import('src/components/organisms/SummaryTable'));

/**
 * A card component displaying the CII Vessel Summary.
 * @component
 * @param {CiiSummaryCardProps} props - The props for the CiiSummaryCard component.
 * @param {boolean} props.isLoading - Indicates whether the data is loading.
 * @param {CiiSummaryData} props.data - The data for the CII Vessel Summary.
 * @returns {ReactElement} The CiiSummaryCard component.
 */
export const CiiSummaryCard = ({ isLoading, data }: CiiSummaryCardProps) => (
  <Card maxW={{ base: 'auto', md: 90 }} p={3} data-testid='cii-summary-card'>
    <Flex justifyContent='space-between' mb={3} alignItems='center'>
      <Text fontSize={{ base: 'md', lg: 'xl' }} fontWeight='semibold' lineHeight={2}>
        CII Vessel Summary
      </Text>
      <Box border='section' borderRadius='base' p={1}>
        <Text fontSize='s' fontWeight='medium' lineHeight={2} pl={1}>
          {text.ytd}
        </Text>
        <Text fontSize='s' lineHeight={1.5} backgroundColor='table.cell' border='base' borderRadius='base' px={1}>
          {text.eoy}
        </Text>
      </Box>
    </Flex>
    <TableContainer border='section' borderRadius='base' minH={40}>
      {isLoading && <Spinner minH={40} size='xl' />}
      {!isLoading && !!data && <SummaryTable data={data} />}
    </TableContainer>
    <Flex justifyContent='end' mt={2}>
      <NextLink href={AppPath.FLEET_CII_RATINGS} passHref legacyBehavior>
        <Link fontSize='s' lineHeight={2} px={2}>
          View All
        </Link>
      </NextLink>
    </Flex>
  </Card>
);
